export { default as TeamChatPinnedStrip } from './TeamChatPinnedStrip';
